import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonColor, Input } from 'react-magma-dom';
import { useDispatch, useSelector } from 'react-redux';

import { resetChiSquareForm } from '../../../store/form/inferentialStatistics/chiSquare/actions';
import { resetParametersInferentialStatistics } from '../../../store/scenes/inferentialStatistics/actions';
import { setPrimaryParameterName } from '../../../store/scenes/graphicalStatistics/settingsPane/actions';
import { isRequired, maxLength } from '../../../utilities/validators';
import {
  setSummary,
  setNameOfColumns,
  setFrequencyDataSet,
  getFrequencyColumnHeaders
} from 'store/dataset';

import {
  getCalculateFrequencyDataSet,
  getCalculateFrequencyDatasetSummary
} from 'calculators/dataset/frequencyTable';

const UpdateColumnVariableComponent = props => {
  const { isContingencyTable, dataSet } = props;
  const dispatch = useDispatch();

  const columnHeaderValue = useSelector(state => getFrequencyColumnHeaders(state));

  const [columnVariableName, setColumnVariableName] = useState(columnHeaderValue);

  const handleInputChange = e => {
    setColumnVariableName(e.target.value);
  };
  const handleColumnVariableNameError = () => {
    return isRequired(columnVariableName) || maxLength(25)(columnVariableName);
  };

  const updateColumnHeader = () => {
    if (handleColumnVariableNameError()) {
      return;
    }
    if (isContingencyTable) {
      const calculatedFrequencyFromDataset = getCalculateFrequencyDataSet(dataSet, columnVariableName);
      dispatch(setFrequencyDataSet(calculatedFrequencyFromDataset));

      const summary = getCalculateFrequencyDatasetSummary(calculatedFrequencyFromDataset);
      dispatch(setSummary(summary));
    }
    dispatch(setNameOfColumns(columnVariableName));
    dispatch(setPrimaryParameterName(columnVariableName));
    dispatch(resetChiSquareForm());
    dispatch(resetParametersInferentialStatistics());
  };

  return (
    <div>
      <Input
        testId="column-variable-name-input"
        labelText="Column Variable Name"
        errorMessage={handleColumnVariableNameError()}
        value={columnHeaderValue}
        onChange={handleInputChange}
      />
      <Button
        testId="column-variable-update-button"
        color={ButtonColor.success}
        onClick={updateColumnHeader}
        style={{ width: '100%', margin: '19px 0 15px 0', fontSize: 14 }}
      >
        Update Table
      </Button>
    </div>
  );
};

UpdateColumnVariableComponent.propTypes = {
  isContingencyTable: PropTypes.bool.isRequired,
  dataSet: PropTypes.array
};

export default UpdateColumnVariableComponent;
